module.exports = __webpack_public_path__ + "0ad9216e1bea5b7dba545da58e29ea1f.png";